import React, { useRef } from "react";
import "./Join.css";
// import emailjs from "@emailjs/browser";

const Join = () => {
  const form = useRef()

  // const sendEmail = (e) => {
  //   e.preventDefault();

  //   emailjs.sendForm('Your_Service_Id', 'Your_Template_Id', form.current,'Your_User_Id')
  //   .then((result) => {
  //     console.log(result.text);
  //   }, (error) =>{
  //     console.log(error.text);
      
  //   })
  // };
  return (
    <div className="Join" id="join-us">
      <div className="left-j">
        <hr />
        <div>
          <span className="stroke-text">Ready To</span>
          <span>Level Up</span>
        </div>
        <div>
          <span>Your Body</span>
          <span className="stroke-text">White Us?</span>
        </div>
      </div>
      <div className="right-j">
        <form ref={form} className="email-container">
          <input type="email" name="user_email" placeholder="Enter your Email address" />
          <button className="btn btn-j">Join Now</button>
        </form>
      </div>
    </div>
  );
};

export default Join;
